import * as React from 'react'

import { Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

interface Props {
  field: Field
  readonly: boolean
  onChange: (value: boolean) => void
}

const Approval = ({ field, onChange, readonly }: Props) => (
  <Card extra={{ 'data-intercom-target': 'leave-type-approval-input' }}>
    <Card.Title
      size="small"
      action={<TogglerCheckbox value={!field.value} onChange={onChange} disabled={readonly} />}
    >
      {i18n.t('settings.leave_types.page.approval.form.approval_required.label')}
    </Card.Title>
  </Card>
)

export default Approval
